import { useMemo } from 'react'

import { FormConfig } from '@workwave-tidal/core/form'

import { useLanguageAndFormatsData } from '../hooks/useLanguageAndFormatsData'
import { useTexts } from './hooks/useTexts'

import { LanguageAndFormatsForm } from './LanguageAndFormatsForm'
import { Footer } from './components/Footer'

import { form } from './formState'
import { LanguageAndFormatsFormValues } from './typings'

type Props = {
  onDiscard: () => void
}

export function LanguageAndFormatsFormProvider(props: Props) {
  const { onDiscard } = props

  const texts = useTexts()

  const [languageAndPreferences, updateLanguageAndFormats] = useLanguageAndFormatsData()

  const config = useMemo<FormConfig<LanguageAndFormatsFormValues>>(
    () => ({
      id: 'language-and-formats-form',
      initialValues: languageAndPreferences,
    }),
    [languageAndPreferences],
  )

  return (
    <form.Form
      testId="language-and-formats-form"
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      footer={<Footer />}
      onSubmit={formValues => updateLanguageAndFormats(formValues, onDiscard)}
      config={config}
      requireTransaction={false}
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
    >
      <LanguageAndFormatsForm />
    </form.Form>
  )
}
